// extracted by mini-css-extract-plugin
export var transparent = "PlayStoreBadge-module--transparent--26d47";
export var wrapper = "PlayStoreBadge-module--wrapper--e3afa";